export const USER_TYPE__CUSTOMER = "customer";
export const USER_TYPE__BANK_ADVISOR = "bank_advisor";
export const USER_TYPE__GUARANTEE_AGENT = "guarantee_agent";
export const USER_TYPE__LEASING_ADVISOR = "leasing_advisor";
